// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Api } from "../Api/Api";

// const AdminContacts = () => {
//   const [contacts, setContacts] = useState([]);
//   const [editing, setEditing] = useState(null);

//   const fetchContacts = async () => {
//     try {
//       const res = await axios.get(`${Api}/Contact.php`);
//       setContacts(res.data);
//     } catch (err) {
//       Swal.fire("Error", "Failed to fetch contacts", "error");
//     }
//   };

//   useEffect(() => {
//     fetchContacts();
//   }, []);

//   // DELETE
//   const deleteContact = async (id) => {
//     const confirm = await Swal.fire({
//       title: "Delete?",
//       text: "This action cannot be undone.",
//       icon: "warning",
//       showCancelButton: true,
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       await axios.delete(`${Api}/Contact.php?id=${id}`);
//       Swal.fire("Deleted!", "", "success");
//       fetchContacts();
//     } catch (err) {
//       Swal.fire("Error", "Delete failed", "error");
//     }
//   };

//   // UPDATE
//   const updateContact = async () => {
//     try {
//       await axios.put(`${Api}/Contact.php`, editing);
//       Swal.fire("Updated!", "", "success");
//       setEditing(null);
//       fetchContacts();
//     } catch (err) {
//       Swal.fire("Error", "Update failed", "error");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-slate-50 p-10">
//       <h2 className="text-3xl font-bold mb-8">Contact Submissions</h2>

//       <div className="overflow-x-auto bg-white shadow rounded-xl">
//         <table className="w-full text-sm">
//           <thead className="bg-indigo-600 text-white">
//             <tr>
//               <th className="p-3">Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Company</th>
//               <th>Service</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {contacts.map((contact) => (
//               <tr key={contact.id} className="border-b">
//                 <td className="p-3">{contact.name}</td>
//                 <td>{contact.email}</td>
//                 <td>{contact.phone}</td>
//                 <td>{contact.company}</td>
//                 <td>{contact.service}</td>
//                 <td className="space-x-2">
//                   <button
//                     onClick={() => setEditing(contact)}
//                     className="bg-yellow-400 px-3 py-1 rounded text-white"
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => deleteContact(contact.id)}
//                     className="bg-red-500 px-3 py-1 rounded text-white"
//                   >
//                     Delete
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* EDIT MODAL */}
//       {editing && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
//           <div className="bg-white p-8 rounded-xl w-[500px] space-y-4">
//             <h3 className="text-xl font-bold">Edit Contact</h3>

//             <input
//               type="text"
//               value={editing.name}
//               onChange={(e) => setEditing({ ...editing, name: e.target.value })}
//               className="w-full border p-2 rounded"
//             />

//             <input
//               type="email"
//               value={editing.email}
//               onChange={(e) =>
//                 setEditing({ ...editing, email: e.target.value })
//               }
//               className="w-full border p-2 rounded"
//             />

//             <input
//               type="text"
//               value={editing.phone}
//               onChange={(e) =>
//                 setEditing({ ...editing, phone: e.target.value })
//               }
//               className="w-full border p-2 rounded"
//             />

//             <input
//               type="text"
//               value={editing.company}
//               onChange={(e) =>
//                 setEditing({ ...editing, company: e.target.value })
//               }
//               className="w-full border p-2 rounded"
//             />

//             <textarea
//               value={editing.service}
//               onChange={(e) =>
//                 setEditing({ ...editing, service: e.target.value })
//               }
//               className="w-full border p-2 rounded"
//             />

//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={() => setEditing(null)}
//                 className="bg-gray-400 px-4 py-2 rounded text-white"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={updateContact}
//                 className="bg-indigo-600 px-4 py-2 rounded text-white"
//               >
//                 Update
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminContacts;

import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Api } from "../Api/Api";
import {
  Trash2,
  Edit3,
  User,
  Mail,
  Phone,
  Building2,
  Briefcase,
} from "lucide-react";

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [editing, setEditing] = useState(null);

  const fetchContacts = async () => {
    try {
      const res = await axios.get(`${Api}/Contact.php`);
      setContacts(res.data);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch contacts", "error");
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const deleteContact = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4f46e5",
      cancelButtonColor: "#ef4444",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(`${Api}/Contact.php?id=${id}`);
      Swal.fire("Deleted!", "Contact has been removed.", "success");
      fetchContacts();
    } catch (err) {
      Swal.fire("Error", "Delete failed", "error");
    }
  };

  const updateContact = async () => {
    try {
      await axios.put(`${Api}/Contact.php`, editing);
      Swal.fire("Updated!", "Contact details updated successfully.", "success");
      setEditing(null);
      fetchContacts();
    } catch (err) {
      Swal.fire("Error", "Update failed", "error");
    }
  };

  return (
    <div className="min-h-screen bg-[#f8fafc]  p-4 md:p-10 font-inter text-slate-900">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl font-black tracking-tight text-slate-800">
              Contact Submissions
            </h2>
            <p className="text-slate-500 mt-1">
              Manage and respond to your business inquiries.
            </p>
          </div>
          <div className="bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-200">
            <span className="text-sm font-medium text-slate-500">
              Total Leads:{" "}
            </span>
            <span className="text-lg font-bold text-indigo-600">
              {contacts.length}
            </span>
          </div>
        </div>

        {/* Table Card */}
        <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/60 border border-slate-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="p-5 text-xs font-bold uppercase tracking-wider text-slate-500">
                    S.No
                  </th>
                  <th className="p-5 text-xs font-bold uppercase tracking-wider text-slate-500">
                    Customer Info
                  </th>
                  <th className="p-5 text-xs font-bold uppercase tracking-wider text-slate-500">
                    Company
                  </th>
                  <th className="p-5 text-xs font-bold uppercase tracking-wider text-slate-500">
                    Service Required
                  </th>
                  <th className="p-5 text-xs font-bold uppercase tracking-wider text-slate-500 text-center">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-100">
                {contacts.map((contact, index) => (
                  <tr
                    key={contact.id}
                    className="hover:bg-indigo-50/20 transition-colors group"
                  >
                    {/* S.No - Reduced padding */}
                    <td className="py-2 px-4 font-medium text-slate-400 text-xs">
                      {String(index + 1).padStart(2, "0")}
                    </td>

                    {/* Customer Info - Stacked with no extra gap */}
                    <td className="py-2 px-4">
                      <div className="flex flex-col leading-tight">
                        <span className="font-bold text-slate-800 text-sm">
                          {contact.name}
                        </span>
                        <div className="flex gap-3 mt-0.5">
                          <span className="text-[11px] text-slate-500 flex items-center gap-1">
                            <Mail size={10} /> {contact.email}
                          </span>
                          <span className="text-[11px] text-slate-500 flex items-center gap-1">
                            <Phone size={10} /> {contact.phone}
                          </span>
                        </div>
                      </div>
                    </td>

                    {/* Company - Compact */}
                    <td className="py-2 px-4">
                      <div className="flex items-center gap-1.5 text-slate-700 text-xs">
                        <Building2 size={14} className="text-slate-400" />
                        <span>{contact.company || "—"}</span>
                      </div>
                    </td>

                    {/* Service - Smaller Badge */}
                    <td className="py-2 px-4">
                      <span className="inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold bg-slate-100 text-slate-600 border border-slate-200 uppercase">
                        {contact.service}
                      </span>
                    </td>

                    {/* Actions - Smaller Buttons */}
                    <td className="py-2 px-4 text-right">
                      <div className="flex justify-end gap-1.5">
                        <button
                          onClick={() => setEditing(contact)}
                          className="p-1.5 text-slate-400 hover:text-amber-600 hover:bg-amber-50 rounded-md transition-all"
                          title="Edit"
                        >
                          <Edit3 size={16} />
                        </button>
                        <button
                          onClick={() => deleteContact(contact.id)}
                          className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-all"
                          title="Delete"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* MODERN EDIT MODAL */}
      {editing && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
            <div className="p-6 border-b border-slate-100 bg-slate-50">
              <h3 className="text-xl font-black text-slate-800">
                Edit Contact Information
              </h3>
            </div>

            <div className="p-8 space-y-5">
              <div className="grid grid-cols-1 gap-4">
                <div className="space-y-1">
                  <label className="text-xs font-bold uppercase text-slate-500 ml-1">
                    Full Name
                  </label>
                  <div className="relative">
                    <User
                      className="absolute left-3 top-3 text-slate-400"
                      size={18}
                    />
                    <input
                      type="text"
                      value={editing.name}
                      onChange={(e) =>
                        setEditing({ ...editing, name: e.target.value })
                      }
                      className="w-full border border-slate-200 pl-10 pr-4 py-2.5 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="text-xs font-bold uppercase text-slate-500 ml-1">
                      Email
                    </label>
                    <input
                      type="email"
                      value={editing.email}
                      onChange={(e) =>
                        setEditing({ ...editing, email: e.target.value })
                      }
                      className="w-full border border-slate-200 px-4 py-2.5 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-bold uppercase text-slate-500 ml-1">
                      Phone
                    </label>
                    <input
                      type="text"
                      value={editing.phone}
                      onChange={(e) =>
                        setEditing({ ...editing, phone: e.target.value })
                      }
                      className="w-full border border-slate-200 px-4 py-2.5 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                    />
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="text-xs font-bold uppercase text-slate-500 ml-1">
                    Company
                  </label>
                  <input
                    type="text"
                    value={editing.company}
                    onChange={(e) =>
                      setEditing({ ...editing, company: e.target.value })
                    }
                    className="w-full border border-slate-200 px-4 py-2.5 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
                  />
                </div>

                <div className="space-y-1">
                  <label className="text-xs font-bold uppercase text-slate-500 ml-1">
                    Service Details
                  </label>
                  <textarea
                    rows="3"
                    value={editing.service}
                    onChange={(e) =>
                      setEditing({ ...editing, service: e.target.value })
                    }
                    className="w-full border border-slate-200 px-4 py-2.5 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none transition-all resize-none"
                  />
                </div>
              </div>
            </div>

            <div className="p-6 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
              <button
                onClick={() => setEditing(null)}
                className="px-6 py-2.5 rounded-xl font-bold text-slate-600 hover:bg-slate-200 transition-all"
              >
                Cancel
              </button>
              <button
                onClick={updateContact}
                className="px-6 py-2.5 rounded-xl font-bold bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg shadow-indigo-200 transition-all"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminContacts;